module.exports = VueSelect;